import {
  Account,
  AccountReconciliation,
  AccountReconciliationResult,
  AccountWithBuckets,
  Bucket,
  CreateAccountReconciliationRequest,
  CreateAccountRequest,
  CreateBucketRequest,
  NetWorthResponse,
  UpdateAccountRequest,
  UpdateBucketRequest,
} from '@financial/shared';
import type { AppCurrency } from '@financial/shared';
import { api } from '../../lib/api';

export async function listAccounts(): Promise<AccountWithBuckets[]> {
  const res = await api.get<AccountWithBuckets[]>('/accounts');
  return res.data;
}

export async function getNetWorth(currency: AppCurrency): Promise<NetWorthResponse> {
  const res = await api.get<NetWorthResponse>('/accounts/net-worth', { params: { currency } });
  return res.data;
}

export async function createAccount(body: CreateAccountRequest): Promise<Account> {
  const res = await api.post<Account>('/accounts', body);
  return res.data;
}

export async function updateAccount(id: string, body: UpdateAccountRequest): Promise<Account> {
  const res = await api.patch<Account>(`/accounts/${id}`, body);
  return res.data;
}

export async function listAccountReconciliations(
  accountId: string,
): Promise<AccountReconciliation[]> {
  const res = await api.get<AccountReconciliation[]>(`/accounts/${accountId}/reconciliations`);
  return res.data;
}

export async function createAccountReconciliation(
  accountId: string,
  body: CreateAccountReconciliationRequest,
): Promise<AccountReconciliationResult> {
  const res = await api.post<AccountReconciliationResult>(
    `/accounts/${accountId}/reconciliations`,
    body,
  );
  return res.data;
}

export async function undoAccountReconciliation(
  accountId: string,
  reconciliationId: string,
): Promise<AccountReconciliationResult> {
  const res = await api.delete<AccountReconciliationResult>(
    `/accounts/${accountId}/reconciliations/${reconciliationId}`,
  );
  return res.data;
}

export async function deleteAccount(id: string): Promise<void> {
  await api.delete(`/accounts/${id}`);
}

export async function createBucket(accountId: string, body: CreateBucketRequest): Promise<Bucket> {
  const res = await api.post<Bucket>(`/accounts/${accountId}/buckets`, body);
  return res.data;
}

export async function updateBucket(
  accountId: string,
  bucketId: string,
  body: UpdateBucketRequest,
): Promise<Bucket> {
  const res = await api.patch<Bucket>(`/accounts/${accountId}/buckets/${bucketId}`, body);
  return res.data;
}

export async function deleteBucket(accountId: string, bucketId: string): Promise<void> {
  await api.delete(`/accounts/${accountId}/buckets/${bucketId}`);
}
